import { Component, inject } from '@angular/core';
import { WaitingListOfferExistsDialogStore } from './waiting-list-offer-exists-dialog.store';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { DateInputComponent } from '../../../kit/input/date-input/date-input.component';
import { AppFormGroup } from '../../../../utils/form.utils';
import { fb } from '../../../../modules/shared/shared.global-service';
import { WaitingListObject } from '@libs/types/src/services/object-type/waiting-list.object';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { isInvalid } from '../../../../modules/shared/helpers/validate';
import { Validators } from '@angular/forms';
import { WarnFloatMessageComponent } from '../../../kit/float-message/warn-float-message.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Chip } from '@openng/optimus-ui/chip';
import { ColorContrastPipe } from '../../../../modules/shared/pipes/color-contrast.pipe';
import { FormatOfferDurationPipe } from '../../../../modules/shared/pipes/format-service-offer-duration.pipe';
import {
    DEFAULT_TAG_COLOR,
} from '../../setting/service-settings-offers-page/service-settings-offer-detail-page/service-settings-offer-detail-page.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { NgStyle } from '@angular/common';
import { NumberInputComponent } from '../../../kit/input/text-input/number-input.component';
import { ActionButtonsComponent } from '../../../kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-waiting-list-offer-exists-dialog',
    templateUrl: './waiting-list-offer-exists-dialog.component.html',
    styleUrls: ['./waiting-list-offer-exists-dialog.component.scss'],
    providers: [WaitingListOfferExistsDialogStore],
    imports: [
        DateInputComponent,
        WarnFloatMessageComponent,
        TranslatePipe,
        Chip,
        ColorContrastPipe,
        FormatOfferDurationPipe,
        Tooltip,
        NgStyle,
        NumberInputComponent,
        ActionButtonsComponent,
    ],
})
export class WaitingListOfferExistsDialogComponent extends BaseDialogComponent {

    public readonly store = inject(WaitingListOfferExistsDialogStore);
    public readonly dialogService = inject(BaseDialogService);

    protected form: AppFormGroup | null = null;

    protected prefix = 'waitingList.offerExists.';

    protected item!: WaitingListObject;

    constructor() {
        super();

        this.item = this.dialogConfig.data.item;

        this.form = new AppFormGroup({
            dateTo: fb.control<Date>(new Date(), Validators.required),
            applications: fb.control<number>(this.item.applications || 0, [Validators.required, Validators.max(this.item.applications || 0)]),
        });
    }

    public override async save(_event: Event) {
        if (isInvalid(this.form)) return;

        this.dialogRef.close(this.form?.value);
    }

    protected readonly DEFAULT_TAG_COLOR = DEFAULT_TAG_COLOR;
}
